import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Box, Button, Grid, makeStyles, TextField } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import MailIcon from '@material-ui/icons/Mail';
import NearMeIcon from '@material-ui/icons/NearMe';
import * as Yup from 'yup';

import styles from './styles';
import { Formik, Form, Field } from 'formik';
import helpers from 'app/utils/helpers';
const useStyles = makeStyles(styles);

const validationSchema = Yup.object().shape({
  deCpfCnpj: Yup.string().required('Documento obrigatório'),
  deEmail: Yup.string()
    .email('Email inválido')
    .required('O email é obrigatório'),
});

function RecoveryForm({ onRecovery }) {
  const classes = useStyles();
  const [deCpfCnpj, setDeCpfCnpj] = useState('');

  const handleChangeDocument = (e, values) => {
    const number = helpers.formatarDocumento(e.target.value);
    setDeCpfCnpj(number);
    values.deCpfCnpj = number;
  };

  return (
    <Formik
      initialValues={{deCpfCnpj:'',deEmail:''}}
      validationSchema={validationSchema}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={values => {
        onRecovery(values);
      }}
    >
      {({ values, errors }) => {
        return (
          <Form>
            <Box maxWidth={400} padding={4}>
              <Grid container spacing={3}>
                <Grid
                  item
                  xs={12}
                  className={[classes.boxRecoveryInfo, classes.textBlue].join(' ')}
                >
                  <h2 className={classes.subtitle}>
                    <FormattedMessage id="LABELS.LOGIN.PASSWORD_RECOVERING" />
                  </h2>
                  <p className={classes.observation}>
                    <FormattedMessage id="LABELS.LOGIN.PASSWORD_RECOVERING_OBS" />
                  </p>
                </Grid>
                <Grid item xs={12} className={classes.boxTextField}>
                  <PersonIcon className={classes.icone} color="disabled" />
                  <Field
                    name="deCpfCnpj"
                    label="CPF/CNPJ"
                    variant="filled"
                    value={deCpfCnpj}
                    fullWidth
                    error={!!errors.deCpfCnpj}
                    onChange={e => handleChangeDocument(e, values)}
                    as={TextField}
                    inputProps={{
                      maxLength: 18,
                    }}
                  />
                </Grid>
                <Grid item xs={12} className={classes.boxTextField}>
                  <MailIcon className={classes.icone} color="disabled" />
                  <Field
                    name="deEmail"
                    type="email"
                    label="Email"
                    variant="filled"
                    fullWidth
                    error={!!errors.deEmail}
                    as={TextField}
                  />
                </Grid>
                <Grid item xs={12} className={classes.item}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    className={classes.loginButton}
                  >
                    <FormattedMessage id="LABELS.COMMONS.SEND" />
                    <NearMeIcon className={classes.iconSend} />
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
}

export default RecoveryForm;
